export const LOCALES = ['en', 'de', 'fi'];
export const DEFAULT_LOCALE = 'en';
export const LOCALE_STORAGE_KEY = 'apex_ui_locale';

/**
 * Path slug → Contentful locale code.
 * Finnish stays off this map until the space has a fi locale.
 * Sync skips slugs that are missing here so English copy is not overlaid on fi.
 */
export const CONTENTFUL_LOCALE_BY_SLUG = {
  en: 'en-US',
  de: 'de',
};

export const LOCALE_LABELS = {
  en: 'EN',
  de: 'DE',
  fi: 'FI',
};

export const LOCALE_NAMES = {
  en: 'English',
  de: 'Deutsch',
  fi: 'suomi',
};

export function hasContentfulLocale(slug) {
  return Object.prototype.hasOwnProperty.call(CONTENTFUL_LOCALE_BY_SLUG, slug);
}

export function toContentfulLocale(slug) {
  return CONTENTFUL_LOCALE_BY_SLUG[slug] || CONTENTFUL_LOCALE_BY_SLUG.en;
}
